@if (control()?.showErrors) {
  <div>
    @for (error of control()?.errorMessages; track error) {
      <p
        class="form-validation-error"
        id="error_{{ error }}"
        >
        {{ error }}
      </p>
    }
  </div>
}
